/**
 * 「你的文案里像是有人出镜」—— 文案 × 选人物 的联动提示(2026-08-06 用户审阅 Q3)。
 *
 * ═══ 为什么做成提示而不是自动挂 ═══════════════════════════════════════════════
 * 产品侧已有联动先例(波3-T4):文案命中产品名 + 产品树有预置图 → ai 在 **compose 响应**里
 * 合成一个 `auto` 标记的实体,用户提交前看得见、可移除。那条路成立是因为判据硬
 * (产品**名**逐字命中产品树里的记录)。
 *
 * 人物这边没有那种硬判据 —— 只能靠「出镜/讲解员/口播」这类词面猜,**猜错的代价还不对称**:
 * 自动挂一个人物 = 逐镜 i2i 锚定 + appearance 逐字进提示词链,整片形象被一个猜测锁死。
 * 所以这里**只提示、不动数据**:说一句「像是有人出镜,要不要锁个形象?」,点不点是他的事。
 *
 * ★不选人物**不是错**:引擎会自产主角(常规手动流是主线,选人是旁路)。措辞因此是
 *   「要不要」而不是「请先」——把可选项写成必填提示,就是又造一道假坎。
 * ★命中词表逐字锁在 `castHint.test.ts`:词面判据一旦悄悄变宽,这条提示就会到处乱弹,
 *   而"提示弹多了就没人看"跟不提示是一样的失败。
 */

/**
 * 出镜信号词。只收**明确指人出镜**的词 ——
 * 「人」「用户」「客户」这类泛称不收:几乎每条带货文案都有,收了就是恒真提示。
 */
export const CAST_SIGNAL_WORDS = [
  "出镜",
  "讲解员",
  "主播",
  "口播",
  "真人",
  "演员",
  "模特",
  "达人",
  "博主",
  "代言",
  "主持",
  "对镜",
] as const;

/** 命中的词(去重、按出现顺序);没命中返空数组。 */
export function castSignals(userInput: string | null | undefined): string[] {
  const t = (userInput ?? "").trim();
  if (!t) return [];
  return CAST_SIGNAL_WORDS.filter((w) => t.includes(w));
}

/**
 * 该不该提示:文案里有出镜信号 **且** 还没选人物。
 * 已选了就别再劝 —— 那是对着已经做过的事催第二遍。
 */
export function shouldHintCast(p: {
  userInput?: string | null;
  characterId?: number | null;
}): boolean {
  return !p.characterId && castSignals(p.userInput).length > 0;
}
